import React from "react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import Image from "../../components/AppImage";
import Button from "../../components/ui/Button";
import { MessageCircle } from "lucide-react";

const JewelryAstralZefiro = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            {/* Agregamos padding-top para compensar la altura del header */}
            <main className="flex-1 flex flex-col items-center justify-center px-6 py-12 pt-24 sm:pt-28 text-center">
                <h1 className="font-headline text-4xl font-bold text-primary mb-2">
                    Joyería Astral Zéfiro
                </h1>
                <h2 className="text-lg text-scholarly-gray mb-6">
                    De: <span className="font-semibold text-primary">Rosa María Cifuentes</span>
                </h2>

                <p className="max-w-2xl text-scholarly-gray mb-10 leading-relaxed text-lg">
                    Líneas Poderosas e Únicas para Tí 🎇 <br />
                    <strong>Cantuarias 140 Tienda 122 - Miraflores 💒</strong> <br />
                    Martes, Jueves, Viernes y Sábados 🕊
                </p>

                <div className="w-full max-w-3xl mb-12">
                    <Image
                        src="/assets/images/jewerly.jpg"
                        alt="Joyería Astral Zéfiro"
                        className="w-full rounded-lg literary-shadow hover:literary-shadow-elevated literary-transition object-cover"
                    />
                </div>

                <Button
                    asChild
                    size="lg"
                    className="bg-primary text-primary-foreground rounded-full px-6 py-3 flex items-center space-x-2 hover:bg-accent literary-transition"
                >
                    <a
                        href="https://wa.me/c/51916070221"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center space-x-2"
                    >
                        <MessageCircle size={20} />
                        <span>Contactar por WhatsApp</span>
                    </a>
                </Button>
            </main>

            <Footer />
        </div>
    );
};

export default JewelryAstralZefiro;
